/* tslint:disable */
/* eslint-disable */
/**
 * back-office-service
 * Back Office Service
 *
 * The version of the OpenAPI document: 0.29.35
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ClaimFormResponse
 */
export interface ClaimFormResponse {
    /**
     * 
     * @type {Date}
     * @memberof ClaimFormResponse
     */
    updatedAt: Date;
    /**
     * 
     * @type {Date}
     * @memberof ClaimFormResponse
     */
    createdAt: Date;
    /**
     * 
     * @type {number}
     * @memberof ClaimFormResponse
     */
    version: number;
    /**
     * 
     * @type {Date}
     * @memberof ClaimFormResponse
     */
    authorizedAt?: Date | null;
    /**
     * 
     * @type {string}
     * @memberof ClaimFormResponse
     */
    authorizedByUserId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ClaimFormResponse
     */
    authorizedByAgentName?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof ClaimFormResponse
     */
    receivedAt?: Date | null;
    /**
     * 
     * @type {string}
     * @memberof ClaimFormResponse
     */
    receivedByUserId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ClaimFormResponse
     */
    receivedByAgentName?: string | null;
    /**
     * The decrypted claim form data. Shape varies by customer — use GET /v1/claim-forms/schema for the expected structure.
     * @type {{ [key: string]: any; }}
     * @memberof ClaimFormResponse
     */
    formData: { [key: string]: any; };
    /**
     * A UUID in its canonical hyphenated form, in either letter case.
     * @type {string}
     * @memberof ClaimFormResponse
     */
    claimReservationId: string | null;
    /**
     * A UUID in its canonical hyphenated form, in either letter case.
     * @type {string}
     * @memberof ClaimFormResponse
     */
    id: string;
}

/**
 * Check if a given object implements the ClaimFormResponse interface.
 */
export function instanceOfClaimFormResponse(value: object): value is ClaimFormResponse {
    if (!('updatedAt' in value) || value['updatedAt'] === undefined) return false;
    if (!('createdAt' in value) || value['createdAt'] === undefined) return false;
    if (!('version' in value) || value['version'] === undefined) return false;
    if (!('formData' in value) || value['formData'] === undefined) return false;
    if (!('claimReservationId' in value) || value['claimReservationId'] === undefined) return false;
    if (!('id' in value) || value['id'] === undefined) return false;
    return true;
}

export function ClaimFormResponseFromJSON(json: any): ClaimFormResponse {
    return ClaimFormResponseFromJSONTyped(json, false);
}

export function ClaimFormResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ClaimFormResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'updatedAt': (new Date(json['updatedAt'])),
        'createdAt': (new Date(json['createdAt'])),
        'version': json['version'],
        'authorizedAt': json['authorizedAt'] == null ? undefined : (new Date(json['authorizedAt'])),
        'authorizedByUserId': json['authorizedByUserId'] == null ? undefined : json['authorizedByUserId'],
        'authorizedByAgentName': json['authorizedByAgentName'] == null ? undefined : json['authorizedByAgentName'],
        'receivedAt': json['receivedAt'] == null ? undefined : (new Date(json['receivedAt'])),
        'receivedByUserId': json['receivedByUserId'] == null ? undefined : json['receivedByUserId'],
        'receivedByAgentName': json['receivedByAgentName'] == null ? undefined : json['receivedByAgentName'],
        'formData': json['formData'],
        'claimReservationId': json['claimReservationId'],
        'id': json['id'],
    };
}

export function ClaimFormResponseToJSON(value?: ClaimFormResponse | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'updatedAt': ((value['updatedAt']).toISOString()),
        'createdAt': ((value['createdAt']).toISOString()),
        'version': value['version'],
        'authorizedAt': value['authorizedAt'] == null ? undefined : ((value['authorizedAt'] as any).toISOString()),
        'authorizedByUserId': value['authorizedByUserId'],
        'authorizedByAgentName': value['authorizedByAgentName'],
        'receivedAt': value['receivedAt'] == null ? undefined : ((value['receivedAt'] as any).toISOString()),
        'receivedByUserId': value['receivedByUserId'],
        'receivedByAgentName': value['receivedByAgentName'],
        'formData': value['formData'],
        'claimReservationId': value['claimReservationId'],
        'id': value['id'],
    };
}

